/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AggregationResource } from './';
import {
    AggregationResourceFromJSON,
    AggregationResourceFromJSONTyped,
    AggregationResourceToJSON,
} from './';
import type { ClientProjectResource } from './';
import {
    ClientProjectResourceFromJSON,
    ClientProjectResourceFromJSONTyped,
    ClientProjectResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientProjectsManagementSearchResultResource
 */
export interface ClientProjectsManagementSearchResultResource {
    /**
     * 
     * @type {Array<ClientProjectResource>}
     * @memberof ClientProjectsManagementSearchResultResource
     */
    results: Array<ClientProjectResource>;
    /**
     * 
     * @type {number}
     * @memberof ClientProjectsManagementSearchResultResource
     */
    totalElements: number;
    /**
     * 
     * @type {{ [key: string]: Array<AggregationResource>; }}
     * @memberof ClientProjectsManagementSearchResultResource
     */
    aggregations: { [key: string]: Array<AggregationResource>; };
}

/**
 * Check if a given object implements the ClientProjectsManagementSearchResultResource interface.
 */
export function instanceOfClientProjectsManagementSearchResultResource(value: object): value is ClientProjectsManagementSearchResultResource {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('aggregations' in value) || value['aggregations'] === undefined) return false;
    return true;
}

export function ClientProjectsManagementSearchResultResourceFromJSON(json: any): ClientProjectsManagementSearchResultResource {
    return ClientProjectsManagementSearchResultResourceFromJSONTyped(json, false);
}

export function ClientProjectsManagementSearchResultResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientProjectsManagementSearchResultResource {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(ClientProjectResourceFromJSON)),
        'totalElements': json['totalElements'],
        'aggregations': json['aggregations'],
    };
}

export function ClientProjectsManagementSearchResultResourceToJSON(value?: ClientProjectsManagementSearchResultResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map((v) => ClientProjectResourceToJSON(v))),
        'totalElements': value['totalElements'],
        'aggregations': value['aggregations'],
    };
}

